<template>
  <v-container fluid class="px-1 py-1">
    <CommonTable
        :title=title
        :embedded="embedded"
        :height="height"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreComponent/Subcategory/CoreSubcategoryDetail"
        :parent-component="$options.name"
        @alternate_action="$emit('alternate_action', $event)"
    >
      <template v-slot:bar>
        <slot name="bar"></slot>
      </template>
      <template v-slot:top>
        <slot name="top"></slot>
      </template>
      <template v-slot:top.bar.filter>
        <slot name="top.bar.filter"></slot>
      </template>
      <template v-slot:item.category__category="{ item }">
        <span v-if="!!item.category_uid && !!storeAggregate.rootData[item.category_uid]">
          {{ storeAggregate.rootData[item.category_uid].category }}
        </span>
      </template>
      <template v-slot:footer.prepend>
        <slot name="footer.prepend"></slot>
      </template>
    </CommonTable>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import BaseImageCard from "@/components/Base/BaseImageCard";
import CommonTaskIcon from "@/components/Common/CommonTaskIcon";
import {useDetailStore} from "@/components/Common/CommonDetail";

export default {
  name: "CoreSubcategoryTable",

  props: {
    title: {default: 'Subcategory'},
    embedded: {default: false},
    height: {default: null},
    headers: {default: null},
    storeName: {
      type: [String], default() {
        return uuidv4()
      }
    },
    dtoDetailQuery: {default: 'SubcategoryDetailQueryDTO'},
    detailStoreName: {
      type: [String], default() {
        return uuidv4()
      }
    },
    dtoListQuery: {type: [String], default: 'SubcategoryListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'SubcategoryActionCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
  },

  components: {
    CommonTable,
    // SubcategoryDetail,
    CoreSubcategoryDetail: () => import("@/components/CoreComponent/Subcategory/CoreSubcategoryDetail"),
    BaseImageCard,
    CommonTaskIcon,
  },

  methods: {
   },


  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    this.storeDetail = useDetailStore(this.detailStoreName)()
    this.storeTable.headers = this.headers || [
      {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
      {text: 'subcategory', value: 'subcategory', article_type: true, filterable: true, divider: true, width: 150},
      {text: 'Valid', value: 'valid', article_type: true, filterable: true, divider: true, width: 70, type: 'bool'},
      {text: 'category', value: 'category__category', article_type: true, filterable: true, divider: true, width: 150},
      {text: 'Maybe common', value: 'maybe_common', article_type: true, filterable: true, divider: true, width: 30, type: 'bool'},
      {text: 'Maybe resistor', value: 'maybe_resistor', article_type: true, filterable: true, divider: true, width: 30, type: 'bool'},
      {text: 'Maybe capacitor', value: 'maybe_capacitor', article_type: true, filterable: true, divider: true, width: 30, type: 'bool'},
      {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
    this.storeAggregate = useAggregateStore()
    if (!!this.storeTable) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
      this.storeTable.options.sortBy = ['subcategory']
      this.storeTable.options.sortDesc = [true]
    }
  },

  data() {
    return {
      storeTable: null,
    }
  },
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>